const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_auth.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * Pathless layout for the auth screens (`/login`, `/forgot-password`,
 * `/auth-action`). Provides the shared two-pane chrome — a centered card with
 * the logo on the left and the brand hero image on the right — and renders the
 * active auth screen into the card via `<Outlet />`. Child screens render only
 * their inner content (header + form); the card spacing (`gap-8`) flows through
 * the transparent Outlet fragment.
 *
 * No auth guard here: `/auth-action` (password-reset confirmation from an email
 * link) must work regardless of session, so the signed-in redirect stays on the
 * individual `login` / `forgot-password` routes.
 *
 * The pane scrolls (`overflow-y-auto`) because the taller screens — application and
 * invitation registration — exceed a short viewport. Centering is `my-auto` on
 * the card rather than `justify-center` on the pane: a centered flex container
 * clips the top of an overflowing child, leaving it unreachable.
 */